import dayjs from 'dayjs'
import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { DateInput } from 'semantic-ui-calendar-react'
import { Form } from 'semantic-ui-react'
import ProfileSettingsService from '~/api/services/profileSettings'
import Dialog from '~/components/Dialog'
import notify from '~/components/Notify'
import TwoFaComp from '~/components/TwoFaComp'
import { useAuth } from '~/routes/components/AuthProvider'
import { KeyLabelType } from '~/types'
import { handleErrors } from '~/utils/helpers'

interface CreateBankFileProps {
  openModal: boolean
  handleClose: (submitted?) => void
  selectedMonth: KeyLabelType
  handleSubmit: (date, text, data) => void
}

const CreateBankFile: React.FC<CreateBankFileProps> = (props) => {
  const { t } = useTranslation()
  const { openModal, handleClose, selectedMonth, handleSubmit } = props
  const { systemData: { languages, logged: { languageId } }, systemData } = useAuth()
  const languageLocal = languages.find(language => language.id === languageId)
  const tfaGenerateBankFile = systemData?.roleSettings?.tfaGenerateBankFile === 1
  const tfaType = systemData?.logged?.tfaType

  const [correctTfaCode, setCorrectTfaCode] = useState(false)
  const [tfaCode, setTfaCode] = useState('')

  const [openExportBankModal, setOpenExportBankModal] = useState(openModal)
  const [isBusy, setIsBusy] = useState(false)
  const [date, setDate] = useState('')
  const [text, setText] = useState('')

  useEffect(() => {
    if (tfaGenerateBankFile && openModal) {
      handleSendCode()
    }
    setOpenExportBankModal(openModal)
    setDate('')
    setText('')
  }, [openModal])

  async function handleSendCode() {
    if (tfaType === 'email' || tfaType === 'sms') {
      setIsBusy(true)
      try {
        await ProfileSettingsService.sendCode()
        notify(t('Code sent'), 'success')
      } catch (error) {
        handleErrors(error)
      }
      setIsBusy(false)
    }
  }

  const handleKeyPress = (event) => {
    event.preventDefault();
  }

  return <Dialog
    isDialogOpen={openExportBankModal}
    handleClose={() => handleClose()}
    isLoading={isBusy}
    textHeader={t('SEPA XML for {{month}}', { month: selectedMonth?.label })}
    textSubmit={t('SEPA XML')}
    textClose={t('Cancel')}
    disableSubmit={isBusy || tfaGenerateBankFile ? !correctTfaCode : !date || text === ''}
    handleSubmit={() => handleSubmit(date, text, tfaCode ? { code: tfaCode } : false)}
    textContent={<>
      <Form>
        <DateInput
          name='date'
          autoComplete='off'
          placeholder={t('Transfer date')}
          minDate={dayjs(new Date()).add(1, 'day').format('DD.MM.YYYY')}
          closable
          clearIcon={'close'}
          onKeyPress={handleKeyPress}
          clearable
          localization={languageLocal.code}
          closeOnMouseLeave={false}
          dateFormat={'DD.MM.YYYY'}
          className={'datePicker'}
          value={date}
          iconPosition='left'
          onChange={(event, { name, value }) => setDate(value)}
        />
        <Form.TextArea
          placeholder={t('Purpose of use')}
          value={text}
          rows={5}
          //@ts-ignore
          onChange={(e, data) => setText(data.value)}
        />
      </Form>
      {tfaGenerateBankFile && <TwoFaComp
        onChangeTfaCode={(code) => setTfaCode(code)}
        onChangeCorrectTfaCode={(correctTfaCode) => setCorrectTfaCode(correctTfaCode)}
      />
      }
    </>
    }
  />
}
export default CreateBankFile